// extracted by mini-css-extract-plugin
export default {"titleSubmission":"SubmissionPage_titleSubmission__H-MCD","container":"SubmissionPage_container__z0Sgh"};